import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "series_small",
  "use": "series_small-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"series_small\"><path d=\"M4.587 25.173v-13.76h18.24v13.76H4.587zm2.24-2.346h13.76v-9.173H6.827v9.173zm2.346-16v2.24h16V20.48h2.24V6.827H9.173z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol